<template>
  <v-btn :variant="getVariant" :width="getWidth" color="primary" rounded="xl" class="text-none" :style="'border-color: ' + getBorderColor" @click.stop="$emit('action')">
    <span :class="getColorClass">
      <slot name="prepend"/>
    </span>
    <span :class="getColorClass">
      <slot name="default"/>
    </span>
    <span :class="getColorClass">
      <slot name="append"/>
    </span>
  </v-btn>
</template>

<script>
export default {
  name: 'BaseActionButton',
  props: ["background", "delete", "width"],
  computed: {
    getVariant() {
      return this.background ? 'flat' : 'outlined';
    },
    getColorClass() {
      if(this.background) {
        return 'sm-white';
      }
      else if(this.delete) {
        return 'sm-error';
      }
      else {
        return 'sm-link';
      }
    },
    getBorderColor() {
      return this.delete ? 'rgba(var(--v-theme-system-error), 0.5)' : 'rgba(var(--v-theme-primary), 0.5)';
    },
    getWidth() {
      return this.width ? this.width : 'auto';
    }
  },
}
</script>